module.exports = __webpack_public_path__ + "img/znlyjkxt4.fbe6e9bc.jpg";